import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Logo from "../assets/img/logo.svg";

function Navbar(props) {

  return (
    <nav className="navbar navbar-expand-md navbar-dark" style={{ position: 'fixed', width: '100%', zIndex: 3000 }} role="navigation" aria-label="Main navigation">
      <div className="container">
        <Link to="/" className="navbar-brand" aria-label="Home">
          <img src={Logo} alt="Shiwani Portfolio Logo" />
        </Link>
        <button 
          className="navbar-toggler" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbar6"
          aria-controls="navbar6"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="navbar-collapse collapse justify-content-stretch" id="navbar6">
            <ul className="navbar-nav ml-auto">
                <li className={"nav-item" + (props.activeLink === 'work' ? " active" : "")}>
                  <Link className="nav-link" to="/" aria-label="View work portfolio">work</Link>
                </li>
                <li className={"nav-item" + (props.activeLink === 'about' ? " active" : "")}>
                  <Link className="nav-link" to="/" aria-label="About me">about</Link>
                </li>
                <li className={"nav-item" + (props.activeLink === 'contact' ? " active" : "")}>
                  <Link className="nav-link" to="mailto:victorshiwani@gmail.com" aria-label="Contact via email">contact</Link>
                </li>
                <li className="nav-item">
                  <button 
                    className="nav-link" 
                    onClick={(e) => { e.preventDefault(); props.switchMode(); }}
                    aria-label={props.lightMode ? "Switch to dark mode" : "Switch to light mode"}
                    style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                  >
                    <i className={props.lightMode ? "las la-moon" : "las la-sun"} aria-hidden="true"></i>
                  </button>
                </li>
            </ul>
        </div>
      </div>
    </nav>
  )
}

Navbar.propTypes = {
  switchMode: PropTypes.func.isRequired,
  lightMode: PropTypes.bool.isRequired,
  activeLink: PropTypes.string
};

export default Navbar;
